import { TicketStatus, FollowUpStatus } from 'services/order/order.type';
import { ProductsStatuses } from 'state/ordersStatus/ordersStatus.slice';

export const mapToFollowUpStatus = (status: TicketStatus): FollowUpStatus => {
    switch (status) {
        case 'DISPLAYING':
            return 'READY';
        case 'DONE':
            return 'COLLECTED';
        case 'MODIFIED':
        case 'TO_DISPLAY':
        case 'TO_DO':
            return 'PROCESSING';
        case 'CANCELLED':
        case 'TO_CANCEL':
            return 'CANCELLED';
        case 'WAITING':
        default:
            return 'WAITING';
    }
};

// KDS only has 2 statuses for products: DONE and TO_DO
// We don't use the COLLECTED status for products since it's for the order
const mapToProductFollowUpStatus = (status: TicketStatus): FollowUpStatus => {
    switch (status) {
        case 'DONE':
            return 'READY';
        case 'TO_DO':
        default:
            return 'PROCESSING';
    }
};

export const mapToProductsFollowUpStatuses = (
    products: Record<string, { status: TicketStatus }>,
): ProductsStatuses => {
    if (!products) return {};
    return Object.entries(products).reduce(
        (acc, [productId, data]) => ({
            ...acc,
            [productId]: mapToProductFollowUpStatus(data.status),
        }),
        {},
    );
};
